import React, { ReactNode } from 'react';

import { Container, Grid } from '@material-ui/core';

import { useStyles } from './styles';

interface ItemHeaderProps {
  textLabel: ReactNode;
  secondLineHeader?: ReactNode;
  containerNoPadding?: boolean;
}

export const ItemHeader: React.FC<ItemHeaderProps> = props => {
  const classes = useStyles();
  const { textLabel, children, secondLineHeader, containerNoPadding } = props;

  return (
    <div className={classes.itemheader}>
      <Container style={{ padding: containerNoPadding ? 0 : undefined }}>
        <Grid container>
          <Grid
            container
            item
            sm={12}
            md={typeof textLabel === 'string' ? 6 : 12}
            className={classes.titleheader}
          >
            {textLabel}
          </Grid>
          {typeof textLabel === 'string' && (
            <Grid container item sm={12} md={6} className={classes.tablelegend}>
              <Grid item>{children}</Grid>
            </Grid>
          )}
        </Grid>
        {secondLineHeader && (
          <Grid container>
            <Grid container item xs={12} className={classes.titleheader}>
              {secondLineHeader}
            </Grid>
          </Grid>
        )}
      </Container>
    </div>
  );
};
